import { useHTTP, useHTTPQuery } from "@/lib/http";
import type { EmblemSetType } from "@/lib/domain/EmblemSet";
import type { EmblemStatsModel } from "@/features/emblems/api/models/EmblemStatsModel";

export const useEmblemStats = (set: EmblemSetType) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["emblemStats", set],
		queryFn: () => http<EmblemStatsModel[]>({
			method: "GET",
			url: `/emblem/stats?set=${set}`
		})
	});
};
